import { LEGAL_ROUTE_NAMES } from "@/apps/legal/legal.routes";
import { goToField, showAlertOnParent } from "@/shared/utils";
import { t } from "@/i18n";
import { useRoute } from "vue-router";
import { PREVIEW_ROUTE_NAMES } from "@/views/preview/preview.routes";
import { RENDER_ROUTE_NAMES } from "@/views/render/render.routes";
import { LEGAL_PREVIEW_KIND } from "@/apps/legal/legal.routes";
import { useState } from "@/store/vuex-composition-mappers";

export function useLegalGoTo() {
    const { preview } = useState("shared/view", ["preview"]);
    const route = useRoute();
    const name = route.name;
    const currentView = () => {
        if (name === RENDER_ROUTE_NAMES.legalFooter || name === PREVIEW_ROUTE_NAMES.legalFooter) {
            return LEGAL_PREVIEW_KIND.footer;
        }
        if (name === RENDER_ROUTE_NAMES.legalTerms || name === PREVIEW_ROUTE_NAMES.legalTerms) {
            return LEGAL_PREVIEW_KIND.terms;
        }
        if (name === RENDER_ROUTE_NAMES.legalPrivacy || name === PREVIEW_ROUTE_NAMES.legalPrivacy) {
            return LEGAL_PREVIEW_KIND.privacy;
        }
        if (name === RENDER_ROUTE_NAMES.legalAbout || name === PREVIEW_ROUTE_NAMES.legalAbout) {
            return LEGAL_PREVIEW_KIND.about;
        }
    };

    return {
        goToCompanyField(fieldId) {
            goToField(LEGAL_ROUTE_NAMES.projectCompany, currentView(), fieldId);
        },
        goToContentField(fieldId) {
            goToField(LEGAL_ROUTE_NAMES.projectFooterContent, currentView(), fieldId);
        },
        goToSocials() {
            goToField(LEGAL_ROUTE_NAMES.projectFooterSocials, currentView(), "");
        },
        goToStylesField(fieldId) {
            goToField(LEGAL_ROUTE_NAMES.projectStyles, currentView(), fieldId);
        },
        goToLinkField(linkId, fieldId) {
            goToField(
                LEGAL_ROUTE_NAMES.projectFooterNavigation,
                currentView(),
                fieldId,
                "edit-link",
                linkId
            );
        },
        goToCategoryField(categoryId, fieldId) {
            goToField(
                LEGAL_ROUTE_NAMES.projectFooterNavigation,
                currentView(),
                fieldId,
                "edit-category",
                categoryId
            );
        },
        goToFormSubmit(e) {
            if (preview.value) {
                const alert = {
                    title: t("r_shared.preview.title"),
                    message: t("r_shared.preview.actions"),
                    type: "warning",
                };
                showAlertOnParent(alert);
                e.preventDefault();
            }
        },
    };
}
